import { useContext, useEffect, useState } from "react";
import { PreviewContext } from "../../Core/Content/Preview";
import { PageContent } from "../../Core/Content/Types";
export function useNavigation() {
  const preview = useContext(PreviewContext);
  const [links, setLinks] = useState<PageContent["navigation"]>();
  useEffect(() => {
    if (preview.preview) return;
    let active = true;
    fetch("/api/cms/pages/navigation/published", { cache: "no-store" })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (
          active &&
          data?.ok &&
          Array.isArray(data.value?.content?.navigation)
        )
          setLinks(data.value.content.navigation);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, [preview.preview]);
  return preview.navigation || links;
}
